class GuideCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.els.slide || this.els.slide.elements.length < 2) return

    this.setupListeners()
    if (window.innerWidth > 999) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(window, 'resize', this.carouselSwitcher.bind(this))
  }

  carouselSwitcher () {
    if (window.innerWidth > 999 && this.carousel) {
      this.carousel.destroy()
      this.carousel = null
      this.els.slides.element.classList.remove('keen-slider')
      this.els.slide.elements.forEach(el => el.classList.remove('keen-slider__slide'))
    } else if (window.innerWidth < 1000 && !this.carousel) {
      this.carousel = this.setupCarousel()
    }
  }

  setupCarousel () {
    const carouselReveal = this.els.slides.element.classList.contains('pg-Curated_ContentItem-reveal')
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        carouselReveal ? window.BAO.carousel.useReveal(this.els?.slide?.elements) : null,
      ].filter(Boolean),
    )
  }
}

if (!customElements.get('guide-carousel')) {
  customElements.define('guide-carousel', GuideCarousel)
}
